export const Storage = {
  get: <T>(key: string, defaultValue: T): T => {
    try {
      const item = localStorage.getItem(`invoiceflow_${key}`);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  },
  
  set: <T>(key: string, value: T): void => {
    try {
      localStorage.setItem(`invoiceflow_${key}`, JSON.stringify(value));
    } catch (error) {
      console.error(`Error saving ${key} to local storage`, error);
    }
  },

  remove: (key: string): void => {
    localStorage.removeItem(`invoiceflow_${key}`);
  },

  clearAll: (): void => {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('invoiceflow_')) {
        localStorage.removeItem(key);
      }
    });
  }
};